/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.MessagePublishingRpc
 */

export const AgentSenderDiscriminant = 'AGENT_SENDER';
export const AgentSenderDiscriminantKey = '@type';
export const AiInferenceMetadataDiscriminant = 'AI_INFERENCE_METADATA';
export const AiInferenceMetadataDiscriminantKey = '@type';
export const AttachmentDiscriminantKey = '@type';
export const BotSenderDiscriminant = 'BOT_SENDER';
export const BotSenderDiscriminantKey = '@type';
export const CallMetadataDiscriminant = 'CALL_METADATA';
export const CallMetadataDiscriminantKey = '@type';
export const CitationDiscriminant = 'CITATION';
export const CitationDiscriminantKey = '@type';
export const ContactAttachmentDiscriminant = 'CONTACT';
export const ContactAttachmentDiscriminantKey = '@type';
export const CustomerAgentAssignmentDiscriminant = 'CUSTOMER_AGENT_ASSIGNMENT';
export const CustomerAgentAssignmentDiscriminantKey = '@type';
export const EmailMetadataDiscriminant = 'EMAIL_METADATA';
export const EmailMetadataDiscriminantKey = '@type';
export const EmailPreviousRepliesDiscriminant = 'EMAIL_PREVIOUS_REPLIES';
export const EmailPreviousRepliesDiscriminantKey = '@type';
export const EncryptedAttachmentDiscriminant = 'ENCRYPTED_ATTACHMENT';
export const EncryptedAttachmentDiscriminantKey = '@type';

/**
 * Virtual record for map with known enum keys
 */

export const FilesDiscriminant = 'FILES';
export const FilesDiscriminantKey = '@type';
export const InlineImagesDiscriminant = 'INLINE_IMAGES';
export const InlineImagesDiscriminantKey = '@type';
export const IntegratorSenderDiscriminant = 'INTEGRATOR_SENDER';
export const IntegratorSenderDiscriminantKey = '@type';
export const InteractiveCardDiscriminant = 'INTERACTIVE_CARD';
export const InteractiveCardDiscriminantKey = '@type';
export const LocationDiscriminant = 'LOCATION';
export const LocationDiscriminantKey = '@type';
export const MentionsDiscriminant = 'MENTIONS';
export const MentionsDiscriminantKey = '@type';
export const MessageFeedbackRequestDiscriminant = 'MESSAGE_FEEDBACK_REQUEST';
export const MessageFeedbackRequestDiscriminantKey = '@type';
export const MessageHeaderDiscriminant = 'MESSAGE_HEADER';
export const MessageHeaderDiscriminantKey = '@type';
export const MessagePositionDescriptorDiscriminant = 'MESSAGE_POSITION_DESCRIPTOR';
export const MessagePositionDescriptorDiscriminantKey = '@type';
export const QuickLinksDiscriminant = 'QUICK_LINKS';
export const QuickLinksDiscriminantKey = '@type';
export const QuickRepliesDiscriminant = 'QUICK_REPLIES';
export const QuickRepliesDiscriminantKey = '@type';
export const RedactedAttachmentDiscriminant = 'REDACTED_ATTACHMENT';
export const RedactedAttachmentDiscriminantKey = '@type';
export const RichMediaTemplatesDiscriminant = 'RICH_MEDIA_TEMPLATES';
export const RichMediaTemplatesDiscriminantKey = '@type';
export const SenderDiscriminantKey = '@type';
export const SocialMetadataAttachmentDiscriminant = 'SOCIAL_MEDIA_METADATA';
export const SocialMetadataAttachmentDiscriminantKey = '@type';
export const SystemSenderDiscriminant = 'SYSTEM_SENDER';
export const SystemSenderDiscriminantKey = '@type';
export const UnsupportedContentAttachmentDiscriminant = 'UNSUPPORTED_CONTENT';
export const UnsupportedContentAttachmentDiscriminantKey = '@type';
export const VidSenderDiscriminant = 'VID_SENDER';
export const VidSenderDiscriminantKey = '@type';
export const VisitorSenderDiscriminant = 'VISITOR_SENDER';
export const VisitorSenderDiscriminantKey = '@type';
export const WhatsAppTemplateMetadataDiscriminant = 'WHATSAPP_TEMPLATE_METADATA';
export const WhatsAppTemplateMetadataDiscriminantKey = '@type';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const publishMessageToNewThreadRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.MessagePublishingRpc',
  rpcName: 'publishMessageToNewThread',
  auth: 'external',
  fingerprint: 'DzMH4MW0zFCRbNqecNDI-4BUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const publishMessageRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.MessagePublishingRpc',
  rpcName: 'publishMessage',
  auth: 'external',
  fingerprint: 'UZJyaNvpOTcOIGxxuMw0eIBUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};